module.exports = __webpack_public_path__ + "static/media/senddoor.081a0bdb.png";